import { useState, useEffect } from "react";
import PDF from "../../../modules/pdf/utility/PDF";
import {
  useFetchedQdsDocumentSelector,
  useQdsSplitPagesSelector,
} from "../../../store/qdsDocuments";
import { useDispatch } from "react-redux";
import { qdsDocumentsActions } from "../../../store/qdsDocuments/QdsDocumentReducer";
import { useToast } from "../../../components/toast";
import { useTranslation } from "react-i18next";
import { QdsBlobCache } from "../utils/QdsBlobCache";

export function useQdsPdfPages() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const fetchedDocumentData = useFetchedQdsDocumentSelector();
  const splitPages = useQdsSplitPagesSelector();
  const { danger } = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    if (splitPages && splitPages?.length > 0) return;

    const blob = QdsBlobCache.get();
    const convertToImages = async () => {
      if (!fetchedDocumentData?.document?.files || !blob) return;

      try {
        setLoading(true);

        const lastFileIndex = (fetchedDocumentData.document.files.length || 0) - 1;
        const file = new File([blob], fetchedDocumentData?.document?.files?.[lastFileIndex]?.name, {
          type: "application/pdf",
        });

        const imagePages = await PDF.splitIntoImages(file);

        dispatch(qdsDocumentsActions.setQdsSplitPages(imagePages));
      } catch (err: any) {
        danger(t("ERRORS.CONVERT_TO_IMAGES"));
        setError(err.message || "Failed to convert PDF to images");
      } finally {
        setLoading(false);
      }
    };

    convertToImages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [splitPages, fetchedDocumentData?.document?.files]);

  return { loading, error };
}
